import { productType } from '../types';
import { translateFn } from '../../../utils/translator.helper';
import { SupportUrls } from './supportUrls';

export function setTranslation(company: productType, language: string | undefined): Record<any, string> {
  let translation = {};

  switch (company) {
    case productType.CLOUD:
      const cloudTranslation = {
        gettingStarted: {
          onboarding: {
            link: 'https://www.bitdefender.com/business/support/en/77209-358013-onboarding.html',
          },
          supportCenter: {
            link: 'https://www.bitdefender.com/business/support/index.html?lang=en',
          },
          releaseNotes: {
            link: 'https://www.bitdefender.com/business/support/en/77209-78199-gravityzone-control-center.html',
          },
        },
        tabs: {
          basics: {
            item_0: {
              title: translateFn('Platform Management'),
              icon: 'ds-icon-SVA',
              articles: {
                item_0: {
                  text: translateFn('Updates'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-80053-updates.html',
                },
                item_1: {
                  text: translateFn('Maintenance'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-80059-maintenance.html',
                },
                item_2: {
                  text: translateFn('Managing users'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-147314-user-accounts.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-77455-platform-management.html',
              },
            },
            item_1: {
              title: translateFn('GravityZone products & features'),
              icon: 'ds-icon-b_symbol_bold',
              articles: {
                item_0: {
                  text: translateFn('Feature descriptions'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-392437-feature-specific-deployment-guides.html',
                },
                item_1: {
                  text: translateFn('Feature matrix'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-376321-features-distribution.html',
                },
                item_2: {
                  text: translateFn('Product comparisons'),
                  link: 'https://www.bitdefender.com/business/compare.html',
                },
              },
              btn: {
                text: translateFn('All products'),
                link: 'https://www.bitdefender.com/business/all-products.html',
              },
            },
            item_2: {
              title: translateFn('Account management'),
              icon: 'ds-icon-user_menu',
              articles: {
                item_0: {
                  text: translateFn('Account setup & authentication'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-94051-manage-your-account.html',
                },
                item_1: {
                  text: translateFn('Reset password'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-152022-reset-your-password.html',
                },
                item_2: {
                  text: translateFn('User activity log'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-94052-user-activity-log.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-77455-platform-management.html',
              },
            },
            item_3: {
              title: translateFn('Basic installation'),
              icon: 'ds-icon-settings',
              articles: {
                item_0: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-376325-requirements.html',
                },
                item_1: {
                  text: translateFn('First login'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-358013-onboarding.html',
                },
                item_2: {
                  text: translateFn('Security agents'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-157497-install-security-agents---standard-procedure.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-77397-installation.html',
              },
            },
            item_4: {
              title: translateFn('Licensing'),
              icon: 'icon-menu_license',
              articles: {
                item_0: {
                  text: translateFn('Your company'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-118218-manage-your-company.html',
                },
                item_1: {
                  text: translateFn('Product trials'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-262784-product-trials.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-80032-your-profile.html',
              },
            },
            item_5: {
              title: translateFn('Configuration'),
              icon: 'icon-menu_configure',
              articles: {
                item_0: {
                  text: translateFn('Your first policy'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-342907-creating-policies.html',
                },
                item_1: {
                  text: translateFn('Your first exclusion'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-342987-exclusions.html',
                },
                item_2: {
                  text: translateFn('Running tasks'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-155163-running-tasks-on-endpoints.html',
                },
                item_3: {
                  text: translateFn('Using tags'),
                  id: 'using_tags',
                  link: 'https://www.bitdefender.com/business/support/en/77209-245738-using-endpoint-tags.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-77398-security-management.html',
              },
            },
          },
          advancedConfiguration: {
            item_0: {
              title: translateFn('Advanced installation'),
              icon: 'ds-icon-settings',
              articles: {
                item_0: {
                  text: translateFn('Network discovery'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-155221-best-practices.html',
                },
                item_1: {
                  text: translateFn('Relays'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-157497-install-security-agents---standard-procedure.html',
                },
                item_2: {
                  text: translateFn('Security Server'),
                  id: 'security_server',
                  link: 'https://www.bitdefender.com/business/support/en/77209-157495-security-server.html',
                },
                item_3: {
                  text: translateFn('Security for Exchange'),
                  id: 'security_for_exchange',
                  link: 'https://www.bitdefender.com/business/support/en/77209-157523-security-for-exchange.html',
                },
                item_4: {
                  text: translateFn('Mobile Security'),
                  id: 'mobile_security',
                  link: 'https://www.bitdefender.com/business/support/en/77209-300391-mobile-security.html',
                },
                item_5: {
                  text: translateFn('Cloud Security'),
                  id: 'cloud_security',
                  link: 'https://www.bitdefender.com/business/support/en/77209-453798-cloud-security.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-77397-installation.html',
              },
            },
            item_1: {
              title: translateFn('Antimalware'),
              icon: 'icon-edr_review',
              id: 'antimalware',
              articles: {
                item_0: {
                  text: translateFn('Configuration'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-342929-antimalware.html',
                },
                item_1: {
                  text: translateFn('Best practices'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-343019-antimalware.html',
                },
                item_2: {
                  text: translateFn('Troubleshooting'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-343052-antimalware.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-342929-antimalware.html',
              },
            },
            item_2: {
              title: translateFn('Email Security'),
              icon: 'icon-cloud_email_security',
              id: 'email_security',
              articles: {
                item_0: {
                  text: translateFn('Licensing & provisioning'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-295101-licensing---provisioning.html',
                },
                item_1: {
                  text: translateFn('Interface tour'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-294781-the-interface-tour.html',
                },
                item_2: {
                  text: translateFn('Initial setup'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-294785-initial-setup.html',
                },
                item_3: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-295098-requirements.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-294779-email-security.html',
              },
            },
            item_3: {
              title: translateFn('Network Protection'),
              icon: 'ds-icon-menu_network',
              articles: {
                item_0: {
                  text: translateFn('Content Control'),
                  id: 'content_control',
                  link: 'https://www.bitdefender.com/business/support/en/77209-342965-content-control.html',
                },
                item_1: {
                  text: translateFn('Web Protection'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-342966-web-protection.html',
                },
                item_2: {
                  text: translateFn('Network Attack Defense'),
                  id: 'network_attack_defense',
                  link: 'https://www.bitdefender.com/business/support/en/77209-342967-network-attacks.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-343033-network-protection.html',
              },
            },
            item_4: {
              title: translateFn('Patch Management'),
              id: 'patch_management',
              icon: 'ds-icon-patch_management',
              articles: {
                item_0: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-376345-patch-management.html',
                },
                item_1: {
                  text: translateFn('Configuration'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-343001-maintenance-windows.html',
                },
                item_2: {
                  text: translateFn('Running patch tasks'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-155238-patch-tasks.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-343068-patch-management.html',
              },
            },
            item_5: {
              title: translateFn('Bitdefender security agents'),
              icon: 'ds-icon-entity_endpoint',
              articles: {
                item_0: {
                  text: translateFn('Windows guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-36338-windows.html',
                },
                item_1: {
                  text: translateFn('Linux guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-37124-linux.html',
                },
                item_2: {
                  text: translateFn('Mac guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-41481-macos.html',
                },
                item_3: {
                  text: translateFn('Installation use cases'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-157498-install-security-agents---use-cases.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77209-157527-troubleshooting.html',
              },
            },
            item_6: {
              title: translateFn('Integrations'),
              icon: 'ds-icon-entity_cloud_storage',
              articles: {
                item_0: {
                  text: translateFn('Microsoft Active Directory'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-158550-microsoft-active-directory.html',
                },
                item_1: {
                  text: translateFn('Veeam'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-158584-veeam-backup---replication.html',
                },
                item_2: {
                  text: translateFn('Splunk'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-171475-splunk.html',
                },
                item_3: {
                  text: translateFn('Amazon'),
                  id: 'amazon',
                  link: 'https://www.bitdefender.com/business/support/en/77209-158520-amazon-aws--ec2-.html',
                },
                item_4: {
                  text: translateFn('Public API'),
                  link: 'https://www.bitdefender.com/business/support/en/77209-125277-public-api.html',
                },
              },
              btn: {
                text: translateFn('Full list'),
                link: 'https://www.bitdefender.com/business/support/en/77209-80061-integrations.html',
              },
            },
          },
        },
        bitdefenderMasterclass: {
          btn: {
            link: 'https://bitdefender.com/masterclass',
          },
        },
        contactUs: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
        },
        technicalAssistance: {
          btn_1: {
            link: SupportUrls.TECHNICAL_ASSISTANCE,
          },
        },
        malwareAssistance: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/submit/',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/77209-343054-resolving-legitimate-applications-detected-as-threats-by-bitdefender.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/77209-343053-using-bdsyslog-to-submit-forensic-information-and-suspicious-files-for-analysis.html',
          },
          btn_4: {
            link: 'https://download.bitdefender.com/supporttools/bdsyslog/v2/BDSysLog_i.exe?_gl=1*1aa2j31*_ga*MTkxNjc3ODM0MC4xNjY5MzkxOTQ3*_ga_6M0GWNLLWF*MTY3ODY5OTg2Ni4xNTUuMC4xNjc4Njk5ODY2LjYwLjAuMA..',
          },
        },
        uninstallBest: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/support/en/77209-87953-uninstalling-security-agents.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/77209-80124-using-the-uninstall-tool-to-remove-bitdefender-endpoint-security-tools.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/site/Downloads/uninstallIntro/uninstall_business.html',
          },
        },
        faq: {
          links: {
            twoFA: {
              text: translateFn('Enforcing two-factor authentication (2FA)'),
              link: 'https://www.bitdefender.com/business/support/en/77209-149659-enforcing-two-factor-authentication--2fa--in-gravityzone-cloud-faq.html',
            },
            cloudSecurityProducts: {
              text: translateFn('Bitdefender cloud security products'),
              link: 'https://www.bitdefender.com/business/support/en/77209-63277-bitdefender-cloud-security-products-faq.html',
            },
            securityAgent: {
              text: translateFn('Bitdefender security agent '),
              link: 'https://www.bitdefender.com/business/support/en/77209-63278-bitdefender-security-agent-faq.html',
            },
            fullDiskEncryption: {
              text: translateFn('GravityZone Full Disk Encryption'),
              link: 'https://www.bitdefender.com/business/support/en/77209-63279-gravityzone-full-disk-encryption-faq.html',
            },
            patchManagement: {
              text: translateFn('Patch Management'),
              link: 'https://www.bitdefender.com/business/support/en/77209-215271-patch-management-faq.html',
            },
          },
          btn: {
            link: 'https://www.bitdefender.com/business/support/en/77209-49983-faq.html',
          },
        },
        enterpriseCommunity: {
          btn: {
            link: 'https://community.bitdefender.com/en/categories/enterprise-security',
          },
        },
        legal: {
          btn_1: {
            link:
              'https://www.bitdefender.' +
              (language !== 'en' ? language : 'com') +
              '/site/view/eula-business-solutions.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/site/view/legal-privacy.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/77209-80152-open-source-software-used-by-bitdefender-enterprise-products.html',
          },
          btn_4: {
            link: 'https://www.bitdefender.com/media/materials/legal/Reselling_Terms_and_Conditions_PAN.pdf',
          },
        },
      };
      translation = cloudTranslation;
      break;

    case productType.PARTNER:
      const partnerTranslation = {
        gettingStarted: {
          onboarding: {
            link: 'https://www.bitdefender.com/business/support/en/77211-358013-onboarding.html',
          },
          supportCenter: {
            link: 'https://www.bitdefender.com/business/support/index.html?lang=en',
          },
          releaseNotes: {
            link: 'https://www.bitdefender.com/business/support/en/77211-78199-gravityzone-control-center.html',
          },
        },
        tabs: {
          basics: {
            item_0: {
              title: translateFn('Platform Management'),
              icon: 'ds-icon-SVA',
              articles: {
                item_0: {
                  text: translateFn('Updates'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-80053-updates.html',
                },
                item_1: {
                  text: translateFn('Maintenance'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-80059-maintenance.html',
                },
                item_2: {
                  text: translateFn('Managing users'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-147314-user-accounts.html',
                },
                item_3: {
                  text: translateFn('Managing companies'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-79437-manage-company-accounts.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-77455-platform-management.html',
              },
            },
            item_1: {
              title: translateFn('GravityZone products & features'),
              icon: 'ds-icon-b_symbol_bold',
              articles: {
                item_0: {
                  text: translateFn('Feature descriptions'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-392437-feature-specific-deployment-guides.html',
                },
                item_1: {
                  text: translateFn('Feature matrix'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-376321-features-distribution.html',
                },
                item_2: {
                  text: translateFn('Product comparisons'),
                  link: 'https://www.bitdefender.com/business/compare.html',
                },
              },
              btn: {
                text: translateFn('All products'),
                link: 'https://www.bitdefender.com/business/all-products.html',
              },
            },
            item_2: {
              title: translateFn('Account management'),
              icon: 'ds-icon-user_menu',
              articles: {
                item_0: {
                  text: translateFn('Account setup & authentication'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-94051-manage-your-account.html',
                },
                item_1: {
                  text: translateFn('Reset password'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-152022-reset-your-password.html',
                },
                item_2: {
                  text: translateFn('User activity log'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-94052-user-activity-log.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-77455-platform-management.html',
              },
            },
            item_3: {
              title: translateFn('Basic installation'),
              icon: 'ds-icon-settings',
              articles: {
                item_0: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-376325-requirements.html',
                },
                item_1: {
                  text: translateFn('First login'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-358013-onboarding.html',
                },
                item_2: {
                  text: translateFn('Security agents'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-157497-install-security-agents---standard-procedure.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-77397-installation.html',
              },
            },
            item_4: {
              title: translateFn('Licensing'),
              icon: 'icon-menu_license',
              articles: {
                item_0: {
                  text: translateFn('Your company'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-118218-manage-your-company.html',
                },
                item_1: {
                  text: translateFn('Managed companies'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-129487-licensing.html',
                },
                item_2: {
                  text: translateFn('Product trials'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-262784-product-trials.html',
                },
                item_3: {
                  text: translateFn('Calculate monthly usage'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-80016-use-cases.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-80032-your-profile.html',
              },
            },
            item_5: {
              title: translateFn('Configuration'),
              icon: 'icon-menu_configure',
              articles: {
                item_0: {
                  text: translateFn('Your first policy'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-342907-creating-policies.html',
                },
                item_1: {
                  text: translateFn('Protection modules'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-342921-configuring-computer-and-virtual-machine-policies.html',
                },
                item_2: {
                  text: translateFn('Your first exclusion'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-342987-exclusions.html',
                },
                item_3: {
                  text: translateFn('Running tasks'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-155163-running-tasks-on-endpoints.html',
                },
                item_4: {
                  text: translateFn('Using tags'),
                  id: 'using_tags',
                  link: 'https://www.bitdefender.com/business/support/en/77211-245738-using-endpoint-tags.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-77398-security-management.html',
              },
            },
          },
          advancedConfiguration: {
            item_0: {
              title: translateFn('Advanced installation'),
              icon: 'ds-icon-settings',
              articles: {
                item_0: {
                  text: translateFn('Network discovery'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-155221-best-practices.html',
                },
                item_1: {
                  text: translateFn('Relays'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-157497-install-security-agents---standard-procedure.html',
                },
                item_2: {
                  text: translateFn('Security Server'),
                  id: 'security_server',
                  link: 'https://www.bitdefender.com/business/support/en/77211-157495-security-server.html',
                },
                item_3: {
                  text: translateFn('Security for Exchange'),
                  id: 'security_for_exchange',
                  link: 'https://www.bitdefender.com/business/support/en/77211-157523-security-for-exchange.html',
                },
                item_4: {
                  text: translateFn('Mobile Security'),
                  id: 'mobile_security',
                  link: 'https://www.bitdefender.com/business/support/en/77211-300391-mobile-security.html',
                },
                item_5: {
                  text: translateFn('Cloud Security'),
                  id: 'cloud_security',
                  link: 'https://www.bitdefender.com/business/support/en/77211-453798-cloud-security.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-77397-installation.html',
              },
            },
            item_1: {
              title: translateFn('Antimalware'),
              icon: 'icon-edr_review',
              id: 'antimalware',
              articles: {
                item_0: {
                  text: translateFn('Configuration'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-342929-antimalware.html',
                },
                item_1: {
                  text: translateFn('Best practices'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-343019-antimalware.html',
                },
                item_2: {
                  text: translateFn('Troubleshooting'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-343052-antimalware.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-342929-antimalware.html',
              },
            },
            item_2: {
              title: translateFn('Email Security'),
              icon: 'icon-cloud_email_security',
              id: 'email_security',
              articles: {
                item_0: {
                  text: translateFn('Licensing & provisioning'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-295101-licensing---provisioning.html',
                },
                item_1: {
                  text: translateFn('Interface tour'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-294781-the-interface-tour.html',
                },
                item_2: {
                  text: translateFn('Initial setup'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-294785-initial-setup.html',
                },
                item_3: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-295098-requirements.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-294779-email-security.html',
              },
            },
            item_3: {
              title: translateFn('Network Protection'),
              icon: 'ds-icon-menu_network',
              articles: {
                item_0: {
                  text: translateFn('Content Control'),
                  id: 'content_control',
                  link: 'https://www.bitdefender.com/business/support/en/77211-342965-content-control.html',
                },
                item_1: {
                  text: translateFn('Web Protection'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-342966-web-protection.html',
                },
                item_2: {
                  text: translateFn('Network Attack Defense'),
                  id: 'network_attack_defense',
                  link: 'https://www.bitdefender.com/business/support/en/77211-342967-network-attacks.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-343033-network-protection.html',
              },
            },
            item_4: {
              title: translateFn('Patch Management'),
              id: 'patch_management',
              icon: 'ds-icon-patch_management',
              articles: {
                item_0: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-376345-patch-management.html',
                },
                item_1: {
                  text: translateFn('Configuration'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-343001-maintenance-windows.html',
                },
                item_2: {
                  text: translateFn('Running patch tasks'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-155238-patch-tasks.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-343068-patch-management.html',
              },
            },
            item_5: {
              title: translateFn('Bitdefender security agents'),
              icon: 'ds-icon-entity_endpoint',
              articles: {
                item_0: {
                  text: translateFn('Windows guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-36338-windows.html',
                },
                item_1: {
                  text: translateFn('Linux guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-37124-linux.html',
                },
                item_2: {
                  text: translateFn('Mac guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-41481-macos.html',
                },
                item_3: {
                  text: translateFn('Installation use cases'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-157498-install-security-agents---use-cases.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77211-157527-troubleshooting.html',
              },
            },
            item_6: {
              title: translateFn('Integrations'),
              icon: 'ds-icon-entity_cloud_storage',
              articles: {
                item_0: {
                  text: translateFn('Microsoft Active Directory'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-158550-microsoft-active-directory.html',
                },
                item_1: {
                  text: translateFn('Veeam'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-158584-veeam-backup---replication.html',
                },
                item_2: {
                  text: translateFn('Kaseya'),
                  id: 'kaseya',
                  link: 'https://www.bitdefender.com/business/support/en/77211-80091-kaseya-vsa.html',
                },
                item_3: {
                  text: translateFn('ConnectWise Automate'),
                  id: 'connectwise',
                  link: 'https://www.bitdefender.com/business/support/en/77211-80092-connectwise-automate.html',
                },
                item_4: {
                  text: translateFn('Splunk'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-171475-splunk.html',
                },
                item_5: {
                  text: translateFn('Amazon'),
                  id: 'amazon',
                  link: 'https://www.bitdefender.com/business/support/en/77211-158520-amazon-aws--ec2-.html',
                },
                item_6: {
                  text: translateFn('Public API'),
                  link: 'https://www.bitdefender.com/business/support/en/77211-125277-public-api.html',
                },
              },
              btn: {
                text: translateFn('Full list'),
                link: 'https://www.bitdefender.com/business/support/en/77211-80061-integrations.html',
              },
            },
          },
        },
        bitdefenderMasterclass: {
          btn: {
            link: 'https://bitdefender.com/masterclass',
          },
        },
        contactUs: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
        },
        technicalAssistance: {
          btn_1: {
            link: SupportUrls.TECHNICAL_ASSISTANCE,
          },
        },
        malwareAssistance: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/submit/',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/77211-343054-resolving-legitimate-applications-detected-as-threats-by-bitdefender.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/77211-343053-using-bdsyslog-to-submit-forensic-information-and-suspicious-files-for-analysis.html',
          },
          btn_4: {
            link: 'https://download.bitdefender.com/supporttools/bdsyslog/v2/BDSysLog_i.exe?_gl=1*1aa2j31*_ga*MTkxNjc3ODM0MC4xNjY5MzkxOTQ3*_ga_6M0GWNLLWF*MTY3ODY5OTg2Ni4xNTUuMC4xNjc4Njk5ODY2LjYwLjAuMA..',
          },
        },
        uninstallBest: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/support/en/77211-87953-uninstalling-security-agents.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/77211-80124-using-the-uninstall-tool-to-remove-bitdefender-endpoint-security-tools.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/site/Downloads/uninstallIntro/uninstall_business.html',
          },
        },
        faq: {
          links: {
            twoFA: {
              text: translateFn('Enforcing two-factor authentication (2FA)'),
              link: 'https://www.bitdefender.com/business/support/en/77211-149659-enforcing-two-factor-authentication--2fa--in-gravityzone-cloud-faq.html',
            },
            cloudSecurityProducts: {
              text: translateFn('Bitdefender GravityZone Cloud Security for MSP'),
              link: 'https://www.bitdefender.com/business/support/en/faq--cloud-security-for-msp.html',
            },
            securityAgent: {
              text: translateFn('Bitdefender security agent '),
              link: 'https://www.bitdefender.com/business/support/en/77211-63278-bitdefender-security-agent-faq.html',
            },
            fullDiskEncryption: {
              text: translateFn('GravityZone Full Disk Encryption'),
              link: 'https://www.bitdefender.com/business/support/en/77211-63279-gravityzone-full-disk-encryption-faq.html',
            },
            patchManagement: {
              text: translateFn('Patch Management'),
              link: 'https://www.bitdefender.com/business/support/en/77211-215271-patch-management-faq.html',
            },
          },
          btn: {
            link: 'https://www.bitdefender.com/business/support/en/77211-49983-faq.html',
          },
        },
        enterpriseCommunity: {
          btn: {
            link: 'https://community.bitdefender.com/en/categories/enterprise-security',
          },
        },
        legal: {
          btn_1: {
            link:
              'https://www.bitdefender.' +
              (language !== 'en' ? language : 'com') +
              '/site/view/eula-business-solutions.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/site/view/legal-privacy.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/77211-80152-open-source-software-used-by-bitdefender-enterprise-products.html',
          },
          btn_4: {
            link: 'https://www.bitdefender.com/media/materials/legal/Reselling_Terms_and_Conditions_PAN.pdf',
          },
        },
      };
      translation = partnerTranslation;
      break;

    case productType.GZ:
      const gzTranslation = {
        gettingStarted: {
          onboarding: {
            link: 'https://www.bitdefender.com/business/support/en/77212-358013-onboarding.html',
          },
          supportCenter: {
            link: 'https://www.bitdefender.com/business/support/index.html?lang=en',
          },
          releaseNotes: {
            link: 'https://www.bitdefender.com/business/support/en/77212-78207-gravityzone-control-center.html',
          },
        },
        tabs: {
          basics: {
            item_0: {
              title: translateFn('Platform Management'),
              icon: 'ds-icon-SVA',
              articles: {
                item_0: {
                  text: translateFn('Updates'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-80053-updates.html',
                },
                item_1: {
                  text: translateFn('Maintenance'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-80059-maintenance.html',
                },
                item_2: {
                  text: translateFn('User accounts'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-124349-managing-user-accounts.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-77455-platform-management.html',
              },
            },
            item_1: {
              title: translateFn('GravityZone products & features'),
              icon: 'ds-icon-b_symbol_bold',
              articles: {
                item_0: {
                  text: translateFn('Feature descriptions'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-392437-feature-specific-deployment-guides.html',
                },
                item_1: {
                  text: translateFn('Feature matrix'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-376321-features-distribution.html',
                },
                item_2: {
                  text: translateFn('Product comparisons'),
                  link: 'https://www.bitdefender.com/business/compare.html',
                },
              },
              btn: {
                text: translateFn('All products'),
                link: 'https://www.bitdefender.com/business/all-products.html',
              },
            },
            item_2: {
              title: translateFn('Account management'),
              icon: 'ds-icon-user_menu',
              articles: {
                item_0: {
                  text: translateFn('Account setup & authentication'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-94051-manage-your-account.html',
                },
                item_1: {
                  text: translateFn('Reset password'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-152022-reset-your-password.html',
                },
                item_2: {
                  text: translateFn('User activity log'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-94052-user-activity-log.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-77455-platform-management.html',
              },
            },
            item_3: {
              title: translateFn('Basic installation'),
              icon: 'ds-icon-settings',
              articles: {
                item_0: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-376325-requirements.html',
                },
                item_1: {
                  text: translateFn('GravityZone platform'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-157494-gravityzone-platform.html',
                },
                item_2: {
                  text: translateFn('First login'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-358013-onboarding.html',
                },
                item_3: {
                  text: translateFn('Security agents'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-157497-install-security-agents---standard-procedure.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-77397-installation.html',
              },
            },
            item_4: {
              title: translateFn('Licensing'),
              icon: 'icon-menu_license',
              articles: {
                item_0: {
                  text: translateFn('Enter license keys'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-80030-control-center.html',
                },
                item_1: {
                  text: translateFn('Check license details'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-80030-control-center.html',
                },
                item_2: {
                  text: translateFn('Reset license usage'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-80030-control-center.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-80030-control-center.html',
              },
            },
            item_5: {
              title: translateFn('Configuration'),
              icon: 'icon-menu_configure',
              articles: {
                item_0: {
                  text: translateFn('Your first policy'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-342907-creating-policies.html',
                },
                item_1: {
                  text: translateFn('Your first exclusion'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-342987-exclusions.html',
                },
                item_2: {
                  text: translateFn('Running tasks'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-155163-running-tasks-on-endpoints.html',
                },
                item_3: {
                  text: translateFn('Using tags'),
                  id: 'using_tags',
                  link: 'https://www.bitdefender.com/business/support/en/77212-245738-using-endpoint-tags.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-77398-security-management.html',
              },
            },
          },
          advancedConfiguration: {
            item_0: {
              title: translateFn('Advanced installation'),
              icon: 'ds-icon-settings',
              articles: {
                item_0: {
                  text: translateFn('Network discovery'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-155221-best-practices.html',
                },
                item_1: {
                  text: translateFn('Relays'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-157497-install-security-agents---standard-procedure.html',
                },
                item_2: {
                  text: translateFn('Security Server'),
                  id: 'security_server',
                  link: 'https://www.bitdefender.com/business/support/en/77212-157495-security-server.html',
                },
                item_3: {
                  text: translateFn('Security for Exchange'),
                  id: 'security_for_exchange',
                  link: 'https://www.bitdefender.com/business/support/en/77212-157523-security-for-exchange.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-77397-installation.html',
              },
            },
            item_1: {
              title: translateFn('Application Control'),
              icon: 'icon-Response',
              id: 'application_control',
              articles: {
                item_0: {
                  text: translateFn('Configuration'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-342956-application-control.html',
                },
                item_1: {
                  text: translateFn('Applications discovery'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-155163-running-tasks-on-endpoints.html',
                },
                item_2: {
                  text: translateFn('Application inventory'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-155236-application-inventory.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-155236-application-inventory.html',
              },
            },
            item_2: {
              title: translateFn('Network Protection'),
              icon: 'ds-icon-menu_network',
              articles: {
                item_0: {
                  text: translateFn('Content Control'),
                  id: 'content_control',
                  link: 'https://www.bitdefender.com/business/support/en/77212-342965-content-control.html',
                },
                item_1: {
                  text: translateFn('Web Protection'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-342966-web-protection.html',
                },
                item_2: {
                  text: translateFn('Network Attack Defense'),
                  id: 'network_attack_defense',
                  link: 'https://www.bitdefender.com/business/support/en/77212-342967-network-attacks.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-343033-network-protection.html',
              },
            },
            item_3: {
              title: translateFn('Patch Management'),
              id: 'patch_management',
              icon: 'ds-icon-patch_management',
              articles: {
                item_0: {
                  text: translateFn('Requirements'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-376345-patch-management.html',
                },
                item_1: {
                  text: translateFn('Configuration'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-343001-maintenance-windows.html',
                },
                item_2: {
                  text: translateFn('Running patch tasks'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-155238-patch-tasks.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-343068-patch-management.html',
              },
            },
            item_4: {
              title: translateFn('Bitdefender security agents'),
              icon: 'ds-icon-entity_endpoint',
              articles: {
                item_0: {
                  text: translateFn('Windows guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-36338-windows.html',
                },
                item_1: {
                  text: translateFn('Linux guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-37124-linux.html',
                },
                item_2: {
                  text: translateFn('Mac guide'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-41481-macos.html',
                },
                item_3: {
                  text: translateFn('Installation use cases'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-157498-install-security-agents---use-cases.html',
                },
              },
              btn: {
                text: translateFn('More Articles'),
                link: 'https://www.bitdefender.com/business/support/en/77212-157527-troubleshooting.html',
              },
            },
            item_5: {
              title: translateFn('Integrations'),
              icon: 'ds-icon-entity_cloud_storage',
              articles: {
                item_0: {
                  text: translateFn('Microsoft Active Directory'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-158550-microsoft-active-directory.html',
                },
                item_1: {
                  text: translateFn('Azure AD'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-158579-microsoft-azure.html',
                },
                item_2: {
                  text: translateFn('Veeam'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-158584-veeam-backup---replication.html',
                },
                item_3: {
                  text: translateFn('Splunk'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-171475-splunk.html',
                },
                item_4: {
                  text: translateFn('Amazon'),
                  id: 'amazon',
                  link: 'https://www.bitdefender.com/business/support/en/77212-158574-amazon-ec2.html',
                },
                item_5: {
                  text: translateFn('Public API'),
                  link: 'https://www.bitdefender.com/business/support/en/77212-125277-public-api.html',
                },
              },
              btn: {
                text: translateFn('Full list'),
                link: 'https://www.bitdefender.com/business/support/en/77212-80061-integrations.html',
              },
            },
          },
        },
        bitdefenderMasterclass: {
          btn: {
            link: 'https://bitdefender.com/masterclass',
          },
        },
        contactUs: {
          btn_0: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102884-use-the-gravityzone-logcollector.html',
          },
          btn_1: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/71263-102885-use-the-support-tool-log.html',
          },
        },
        technicalAssistance: {
          btn_1: {
            link: SupportUrls.TECHNICAL_ASSISTANCE,
          },
        },
        malwareAssistance: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/submit/',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/77212-343054-resolving-legitimate-applications-detected-as-threats-by-bitdefender.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/77212-343053-using-bdsyslog-to-submit-forensic-information-and-suspicious-files-for-analysis.html',
          },
          btn_4: {
            link: 'https://download.bitdefender.com/supporttools/bdsyslog/v2/BDSysLog_i.exe?_gl=1*1aa2j31*_ga*MTkxNjc3ODM0MC4xNjY5MzkxOTQ3*_ga_6M0GWNLLWF*MTY3ODY5OTg2Ni4xNTUuMC4xNjc4Njk5ODY2LjYwLjAuMA..',
          },
        },
        uninstallBest: {
          btn_1: {
            link: 'https://www.bitdefender.com/business/support/en/77212-87953-uninstalling-security-agents.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/business/support/en/77212-80124-using-the-uninstall-tool-to-remove-bitdefender-endpoint-security-tools.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/site/Downloads/uninstallIntro/uninstall_business.html',
          },
        },
        faq: {
          links: {
            twoFA: {
              text: translateFn('Enforcing two-factor authentication (2FA)'),
              link: 'https://www.bitdefender.com/business/support/en/77211-149659-enforcing-two-factor-authentication--2fa--in-gravityzone-cloud-faq.html',
            },
            cloudSecurityProducts: {
              text: translateFn('Bitdefender cloud security products'),
              link: 'https://www.bitdefender.com/business/support/en/77211-63277-bitdefender-cloud-security-products-faq.html',
            },
            securityAgent: {
              text: translateFn('Bitdefender security agent '),
              link: 'https://www.bitdefender.com/business/support/en/77212-63278-bitdefender-security-agent-faq.html',
            },
            fullDiskEncryption: {
              text: translateFn('GravityZone Full Disk Encryption'),
              link: 'https://www.bitdefender.com/business/support/en/77212-63279-gravityzone-full-disk-encryption-faq.html',
            },
            patchManagement: {
              text: translateFn('Patch Management'),
              link: 'https://www.bitdefender.com/business/support/en/77212-215271-patch-management-faq.html',
            },
          },
          btn: {
            link: 'https://www.bitdefender.com/business/support/en/77212-49983-faq.html',
          },
        },
        enterpriseCommunity: {
          btn: {
            link: 'https://community.bitdefender.com/en/categories/enterprise-security',
          },
        },
        legal: {
          btn_1: {
            link:
              'https://www.bitdefender.' +
              (language !== 'en' ? language : 'com') +
              '/site/view/eula-business-solutions.html',
          },
          btn_2: {
            link: 'https://www.bitdefender.com/site/view/legal-privacy.html',
          },
          btn_3: {
            link: 'https://www.bitdefender.com/business/support/en/77212-80152-open-source-software-used-by-bitdefender-enterprise-products.html',
          },
          btn_4: {
            link: 'https://www.bitdefender.com/media/materials/legal/Reselling_Terms_and_Conditions_PAN.pdf',
          },
        },
      };
      translation = gzTranslation;
      break;
  }

  return translation;
}
